export default {"src":"/_next/static/media/plug.ffb0369a.svg","height":20,"width":20};